import { Dispatch } from "redux";
import { EmployeeAttendance } from "../../types/Attendance";
import {
  createEmployeeAttendance,
  deleteEmployeeAttendance,
  getAllEmployeeAttendance,
  updateEmployeeAttendance,
} from "../../services/EmployeeAttendanceService";

// Action types
export enum EmployeeAttendanceActionList {
  ADD_EMPLOYEE_ATTENDANCE = "ADD_EMPLOYEE_ATTENDANCE",
  EDIT_EMPLOYEE_ATTENDANCE = "EDIT_EMPLOYEE_ATTENDANCE",
  FETCH_EMPLOYEE_ATTENDANCE = "FETCH_EMPLOYEE_ATTENDANCE",
  DELETE_EMPLOYEE_ATTENDANCE = "DELETE_EMPLOYEE_ATTENDANCE",
}

// Actions
export interface AddEmployeeAttendanceAction {
  type: EmployeeAttendanceActionList.ADD_EMPLOYEE_ATTENDANCE;
  data: EmployeeAttendance;
}

export interface EditEmployeeAttendanceAction {
  type: EmployeeAttendanceActionList.EDIT_EMPLOYEE_ATTENDANCE;
  data: EmployeeAttendance;
  id: number;
}

export interface FetchEmployeeAttendanceAction {
  type: EmployeeAttendanceActionList.FETCH_EMPLOYEE_ATTENDANCE;
  data: EmployeeAttendance[];
}

export interface DeleteEmployeeAttendanceAction {
  type: EmployeeAttendanceActionList.DELETE_EMPLOYEE_ATTENDANCE;
  data: number;
}

export type EmployeeAttendanceActions =
  | AddEmployeeAttendanceAction
  | EditEmployeeAttendanceAction
  | FetchEmployeeAttendanceAction
  | DeleteEmployeeAttendanceAction;

// Action Creators

export const addEmployeeAttendanceAction = (data: EmployeeAttendance) => {
  return async (dispatch: Dispatch) => {
    return createEmployeeAttendance(data)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          dispatch<AddEmployeeAttendanceAction>({
            type: EmployeeAttendanceActionList.ADD_EMPLOYEE_ATTENDANCE,
            data: response.data.data,
          });
          return Promise.resolve(response.data.message ?? "Attendance added");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to add attendance",
        ),
      );
  };
};

export const editEmployeeAttendanceAction = (
  id: number,
  data: EmployeeAttendance,
) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await updateEmployeeAttendance(id, data);
      const updatedData = response.data?.data ?? response.data;

      if (response.status === 200 && response.data) {
        dispatch<EditEmployeeAttendanceAction>({
          type: EmployeeAttendanceActionList.EDIT_EMPLOYEE_ATTENDANCE,
          data: updatedData,
          id,
        });
        return Promise.resolve(
          response.data.message ?? "EmployeeAttendance updated",
        );
      } else {
        throw new Error(response?.data?.message || "Unknown error");
      }
    } catch (error: any) {
      console.error("Update Employee Attendance Error:", error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to update employeeAttendance";

      return Promise.reject(errorMessage);
    }
  };
};

export const fetchEmployeeAttendanceAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getAllEmployeeAttendance();
    dispatch<FetchEmployeeAttendanceAction>({
      type: EmployeeAttendanceActionList.FETCH_EMPLOYEE_ATTENDANCE,
      data: response,
    });
  };
};

export const deleteEmployeeAttendanceAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteEmployeeAttendance(id)
      .then((response) => {
        if (response.status === 200) {
          dispatch<DeleteEmployeeAttendanceAction>({
            type: EmployeeAttendanceActionList.DELETE_EMPLOYEE_ATTENDANCE,
            data: id,
          });
          return Promise.resolve(response.data.message ?? "Attendance deleted");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to delete attendance",
        ),
      );
  };
};
